import { css } from "@styled-system/css";

export const emptyMessageClass = css({
	mr: "2",
});

export const dataTableClass = css({
	mr: "2",
});
